var ia = {
  aria: {},
  instances: []
};

(function() {
  "use strict";

  ia.aria.Accordion = function(el, index) {
    this.id = 'accordion-' + index;
    this.el = el;
    this.initialize();
  }

  ia.aria.Accordion.prototype = {

    tabs: [],
    panels: [],

    initialize: function() {
      this.el.setAttribute('id', this.id);
      this.el.setAttribute('role', 'tablist');
      this.el.setAttribute('aria-multiselectable', 'true');
      
      this.panels = [].slice.call( this.el.getElementsByTagName('dd') );
      
      this.panels.map( function( panel, i ){
        panel.setAttribute('id', this.id + "-panel-" + i);
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labeledby', this.id + "-tab-" + i);
        panel.setAttribute('aria-hidden', 'true');
        panel.addEventListener( 'keydown', this.onPanelKeydown.bind(this), true ); 
      }, this );

      this.tabs = [].slice.call( this.el.getElementsByTagName('dt') );
      this.tabs.map( function( tab, i ){
        tab.setAttribute('role', 'tab');
        tab.setAttribute('id', this.id + "-tab-" + i);
        tab.setAttribute('aria-controls', this.id + "-panel-" + i);
        tab.setAttribute('aria-expanded', false);
        tab.setAttribute('aria-selected', false);
        tab.setAttribute('tabindex', '-1');
        tab.addEventListener('click', this.onTabClick.bind(this));
        tab.addEventListener('keydown', this.onTabKeydown.bind(this));
      }, this );
      
      // Set the first tab as selected and show its pane
      this.select(this.tabs[0]);
      this.show(this.tabs[0]);
      // Remove focus from the selected tab
      this.tabs[0].blur();
    },
    
    getPanel: function(tab) {
      return document.getElementById(tab.getAttribute('aria-controls'));
    },

    select: function(tab) {
      this.deselectAll();
      tab.setAttribute('aria-selected', 'true');
      tab.setAttribute('tabindex', '0');
      tab.focus();
    },

    deselectAll: function() {
      this.tabs.map(function(tab, i){
        tab.setAttribute('aria-selected', 'false');
        tab.setAttribute('tabindex', '-1');
      }, this );
    },

    show: function(tab) {
      this.getPanel(tab).setAttribute('aria-hidden', 'false');
      tab.setAttribute('aria-expanded', 'true');
    },

    hide: function(tab) {
      this.getPanel(tab).setAttribute('aria-hidden', 'true');
      tab.setAttribute('aria-expanded', 'false');
    },

    hideAll: function() {
      this.tabs.map(function(tab){
        this.hide(tab);
      }, this);
    },

    getNextTab: function(tab) {
      var next = tab.nextSibling;
      if (next === null) {
        return this.tabs[0];
      } else if (next.tagName === 'DT') {
        return next;
      } else {
        return this.getNextTab(next);
      }
    },

    getPrevTab: function(tab) {
      var next = tab.previousSibling;
      if (next === null) {
        return this.tabs[this.tabs.length - 1];
      } else if (next.tagName === 'DT') {
        return next;
      } else {
        return this.getPrevTab(next);
      }
    },

    onTabClick: function(e) {
      var showTab = e.target.getAttribute('aria-expanded') !== 'true';
      this.hideAll();
      if (showTab) {
        this.show(e.target);
      }
    },

    onTabKeydown: function(e) {
      switch (e.which) {
        case 13: // ENTER
        case 32: // SPACE
          e.preventDefault();
          e.stopPropagation();
          var showTab = e.target.getAttribute('aria-expanded') !== 'true';
          this.hideAll();
          if (showTab) {
            this.show(e.target);
          }
          break;
        case 37: // LEFT
        case 38: // UP
          e.preventDefault();
          e.stopPropagation();
          this.select(this.getPrevTab(e.target));
          break;
        case 39: // RIGHT
        case 40: // DOWN
          e.preventDefault();
          e.stopPropagation();
          this.select(this.getNextTab(e.target));
          break;
        case 35: // END
          e.preventDefault();
          e.stopPropagation();
          this.select(this.tabs[this.tabs - 1]);
          break;
        case 36: // HOME
          e.preventDefault();
          e.stopPropagation();
          this.select(this.tabs[0]);
          break;
      }
    },

    onPanelKeydown: function(e) {
      if ( e.ctrlKey || e.metaKey ) {
        switch (e.which) {
          case 38: // UP
            e.preventDefault();
            e.stopPropagation();
            if( e.currentTarget ){
              this.select(this.getPrevTab(e.currentTarget)) ; 
            }
            break;
          case 34: // PAGE DOWN
            e.preventDefault();
            e.stopPropagation();
            if( e.currentTarget ){ 
              this.select(this.getNextTab(e.currentTarget)) ; 
            }
            break;
        }
      }
    }
  };

  window.addEventListener('load', function() {
    var accordions = document.getElementsByClassName('accordion');
    for (var i = 0; i < accordions.length; i++) {
      ia.instances[ia.instances.length] = new ia.aria.Accordion(accordions[i], i);
    }
        // Remove focus from the first tab
    var firstAccordion = ia.instances[0];
    if (firstAccordion && firstAccordion.tabs.length > 0) {
      firstAccordion.tabs[0].blur();
    }
    window.scrollTo(0, 0);
  });
})();